import { jsxs as m, jsx as o } from "react/jsx-runtime";
import t from "react";
import n from "styled-components";
import { RangoButtonMini as l } from "./ButtonMini.js";
import { R as g } from "../chunks/Description.be3b00d1.js";
const f = n.div.withConfig({
  displayName: "LoadMore",
  componentId: "sc-qxyiu0-0"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;height:var(--size-6x);box-sizing:border-box;"]), i = t.forwardRef(({
  descriptionProps: a,
  buttonMiniProps: e,
  ...r
}, d) => /* @__PURE__ */ m(f, { ref: d, "data-testid": "rango-load-more", "data-rango-component": "rango-load-more", "data-is-rango": !0, ...r, children: [
  /* @__PURE__ */ o(g, { ...a, children: a == null ? void 0 : a.children }),
  /* @__PURE__ */ o(l, { ...e, children: e == null ? void 0 : e.children })
] }));
i.displayName = "RangoLoadMore";
export {
  i as RangoLoadMore
};
